<template>
  <div class="geo-region-select">
    <div class="geo-box">
      <div class="geo-top">
        <div class="geo-mode" role="group" :aria-label="kind + ' targeting mode'">
          <button type="button" class="inc" :class="{ on: include }" @click="setInclude(true)">Include</button>
          <button type="button" class="exc" :class="{ on: !include }" @click="setInclude(false)">Exclude</button>
        </div>
        <select
          v-if="kind === 'geo'"
          class="geo-sel"
          :value="selectValue"
          @change="onGeoSelect"
        >
          <option value="">{{ placeholder }}</option>
          <option v-for="opt in selectOptions" :key="opt.code" :value="opt.code">{{ opt.label }}</option>
        </select>
        <select
          v-else
          class="geo-sel"
          :value="''"
          @change="onRegionAdd"
        >
          <option value="">{{ placeholder }}</option>
          <option v-for="opt in regionOptions" :key="opt.code" :value="opt.code">{{ opt.label }}</option>
        </select>
      </div>

      <ul v-if="kind === 'region' && codes.length" class="geo-picked">
        <li v-for="(code, index) in codes" :key="code + index" @click="remove(index)" :title="'Remove ' + labelFor(code)">
          <span class="geo-code">{{ code }}</span>
          <span class="geo-name">{{ catalogName(code) }}</span>
          <span class="geo-x">×</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import countries from '@/assets/countries.js'
import regions from '@/assets/us_states.js'

export default {
  name: 'GeoRegionSelect',
  props: {
    value: { type: String, default: '' },
    kind: { type: String, required: true, validator: v => v === 'geo' || v === 'region' }
  },
  data() {
    return {
      include: true,
      codes: []
    }
  },
  computed: {
    catalog() {
      return this.kind === 'geo' ? countries : regions
    },
    placeholder() {
      return this.kind === 'geo' ? 'Select country…' : 'Add region…'
    },
    selectValue() {
      return this.codes[0] || ''
    },
    selectOptions() {
      return this.buildOptions(false)
    },
    regionOptions() {
      return this.buildOptions(true)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.syncFromValue(val)
      }
    }
  },
  methods: {
    buildOptions(excludeSelected) {
      const out = []
      Object.keys(this.catalog).forEach(code => {
        if (excludeSelected && this.codes.includes(code)) return
        out.push({ code, label: `${this.catalog[code]} (${code})` })
      })
      return out.sort((a, b) => a.label.localeCompare(b.label))
    },
    syncFromValue(val) {
      if (!val) {
        this.include = true
        this.codes = []
        return
      }
      const exclude = val.startsWith('!')
      this.include = !exclude
      const raw = exclude ? val.slice(1) : val
      this.codes = raw.split(',').map(s => s.trim()).filter(Boolean)
    },
    catalogName(code) {
      return this.catalog[code] || code
    },
    labelFor(code) {
      return this.catalog[code] ? `${this.catalog[code]} (${code})` : code
    },
    setInclude(next) {
      if (this.include === next) return
      this.include = next
      this.emitValue()
    },
    onGeoSelect(e) {
      const code = e.target.value
      this.codes = code ? [code] : []
      this.emitValue()
    },
    onRegionAdd(e) {
      const code = e.target.value
      e.target.value = ''
      if (!code || this.codes.includes(code)) return
      this.codes.push(code)
      this.emitValue()
    },
    remove(index) {
      this.codes.splice(index, 1)
      this.emitValue()
    },
    emitValue() {
      if (!this.codes.length) {
        this.$emit('input', '')
        return
      }
      const prefix = this.include ? '' : '!'
      this.$emit('input', prefix + this.codes.join(','))
    }
  }
}
</script>
